document.addEventListener(
	"DOMContentLoaded",
	function () {
		if (document.getElementsByClassName( "gform-body" ).length >= 1) {
			gform.addFilter(
				"gform_datepicker_options_pre_init",
				function (optionsObj, formId, fieldId) {
					// All date fields can't be in the past
					optionsObj.minDate = 0;
					return optionsObj;
				}
			);
		}
	}
);
